import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import RepeatTransactionPageUI from './RepeatTransactionPageUI'

const getTodayDateISO = () => {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

class RepeatTransactionPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      eligibilityList: null,
      currentPage: 1,
      totalPages: 1,
      totalOffers: 0,
      hasMore: false,
      offerDate: null,
      loadingPage: false,
      searchQuery: '',
      statusFilter: 'ALL',
      actionModalOpen: false,
      selectedItem: null,
      actionModalType: 'approve',
      isCheckingEligibility: false,
      eligibilityConfirmOpen: false
    }
  }

  componentDidMount() {
    this.getRepeatTransactions(this.props.context, 1)
  }

  getRepeatTransactions = (context, page = 1) => {
    const cacheKey = CacheKeys.RepeatTransactionOffers ? CacheKeys.RepeatTransactionOffers(page) : `RepeatTransactionOffers:${page}`
    let cacheManager = new CacheManager({
      resource: '/api/su/loan/repeatloan/offers',
      cacheKey: cacheKey,
      callback: this.getRepeatTransactionsCallback,
      ttlInSecs: 300
    })
    cacheManager.getObject2(context, null, { page: page })
  }

  getRepeatTransactionsCallback = (response) => {
    if (response && response.errorList && response.errorList.length > 0) {
      this.setState({
        errorList: response.errorList,
        eligibilityList: this.state.eligibilityList || [],
        isCheckingEligibility: false,
        loadingPage: false
      })
    } else if (response) {
      const list = response.repeatOffers || response.eligibilityList || response.preApprovedLoans || response.data || (Array.isArray(response) ? response : [])
      this.setState({
        errorList: null,
        eligibilityList: list,
        currentPage: response.currentPage != null ? response.currentPage : (this.state.currentPage || 1),
        totalPages: response.totalPages != null ? response.totalPages : (this.state.totalPages || 1),
        totalOffers: response.totalOffers != null ? response.totalOffers : list.length,
        hasMore: response.hasMore != null ? response.hasMore : false,
        offerDate: response.offerDate || null,
        isCheckingEligibility: false,
        loadingPage: false
      })
    } else {
      this.setState({
        errorList: null,
        eligibilityList: [],
        isCheckingEligibility: false,
        loadingPage: false
      })
    }
  }

  onRefreshClick = () => {
    CacheManager.removeByPrefix('RepeatTransactionOffers')
    this.setState({
      errorList: null,
      loadingPage: true,
      isCheckingEligibility: false
    }, () => {
      this.getRepeatTransactions(this.props.context, this.state.currentPage || 1)
    })
  }

  // Previous Button: Navigate to Older Check Run (page = currentPage + 1)
  onPreviousPage = () => {
    const { currentPage, totalPages, hasMore, loadingPage, isCheckingEligibility } = this.state
    if (loadingPage || isCheckingEligibility) return
    if (currentPage >= totalPages || hasMore === false) return
    const nextPage = currentPage + 1
    this.setState({
      currentPage: nextPage,
      loadingPage: true,
      errorList: null
    }, () => {
      this.getRepeatTransactions(this.props.context, nextPage)
    })
  }

  // Next Button: Navigate to Newer Check Run (page = currentPage - 1)
  onNextPage = () => {
    const { currentPage, loadingPage, isCheckingEligibility } = this.state
    if (loadingPage || isCheckingEligibility) return
    if (currentPage <= 1) return
    const prevPage = currentPage - 1
    this.setState({
      currentPage: prevPage,
      loadingPage: true,
      errorList: null
    }, () => {
      this.getRepeatTransactions(this.props.context, prevPage)
    })
  }

  onRunEligibilityCheckClick = () => {
    this.setState({
      eligibilityConfirmOpen: true,
      errorList: null
    })
  }

  onEligibilityConfirmModalRequestClose = () => {
    if (this.state.isCheckingEligibility) {
      return
    }
    this.setState({
      eligibilityConfirmOpen: false,
      errorList: null
    })
  }

  onRunEligibilityCheckConfirm = (event) => {
    if (event && event.preventDefault) {
      event.preventDefault()
    }
    if (this.state.isCheckingEligibility) return

    const dateISO = getTodayDateISO()

    this.setState({
      isCheckingEligibility: true,
      errorList: null
    })

    RestApiUtils.get(
      this.props.context,
      '/api/su/loan/repeatloan/eligibility',
      this.onRunEligibilityCheckCallback,
      null,
      { dateISO: dateISO }
    )
  }

  onRunEligibilityCheckCallback = (response) => {
    if (response && response.errorList && response.errorList.length > 0) {
      this.setState({
        errorList: response.errorList,
        isCheckingEligibility: false,
        eligibilityConfirmOpen: true
      })
      return
    }

    CacheManager.removeByPrefix('RepeatTransactionOffers')
    this.setState({
      errorList: null,
      eligibilityList: null,
      currentPage: 1,
      isCheckingEligibility: false,
      eligibilityConfirmOpen: false
    }, () => {
      this.getRepeatTransactions(this.props.context, 1)
    })
  }

  onOpenActionModal = (item, type = 'approve') => {
    this.setState({
      actionModalOpen: true,
      selectedItem: item,
      actionModalType: type
    })
  }

  onCloseActionModal = () => {
    this.setState({
      actionModalOpen: false,
      selectedItem: null
    })
  }

  onActionSuccess = (updatedItem, actionType, remark) => {
    const updatedList = (this.state.eligibilityList || []).map(item => {
      const targetId = updatedItem.id || updatedItem.accountId || updatedItem.latestLoanId || updatedItem.accountName ||
        (updatedItem.loanEntity && (updatedItem.loanEntity.loanId || updatedItem.loanEntity.accountId)) || updatedItem.loanId || updatedItem.clientName
      const currentId = item.id || item.accountId || item.latestLoanId || item.accountName ||
        (item.loanEntity && (item.loanEntity.loanId || item.loanEntity.accountId)) || item.loanId || item.clientName

      const isTarget = (currentId && targetId && currentId === targetId) ||
        (item.id && updatedItem.id && item.id === updatedItem.id) ||
        (item.accountId && updatedItem.accountId && item.accountId === updatedItem.accountId) ||
        (item.latestLoanId && updatedItem.latestLoanId && item.latestLoanId === updatedItem.latestLoanId) ||
        (item.accountName && updatedItem.accountName && item.accountName === updatedItem.accountName)
      if (isTarget) {
        const nextStatus = actionType === 'reject' ? 'Rejected' : 'Approved'
        const now = Date.now()
        const nowISO = new Date().toISOString()
        return {
          ...item,
          offerStatus: nextStatus,
          statusOfLoan: nextStatus,
          status: nextStatus,
          remarks: remark,
          dateUpdated: now,
          dateUpdatedISO: nowISO,
          updatedDate: now,
          updatedDateISO: nowISO
        }
      }
      return item
    })

    CacheManager.removeByPrefix('RepeatTransactionOffers')

    this.setState({
      eligibilityList: updatedList,
      actionModalOpen: false,
      selectedItem: null
    }, () => {
      this.getRepeatTransactions(this.props.context, this.state.currentPage || 1)
    })
  }

  render() {
    return (
      <RepeatTransactionPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        eligibilityList={this.state.eligibilityList}
        loading={!this.state.eligibilityList && !this.state.errorList}
        loadingPage={this.state.loadingPage}
        currentPage={this.state.currentPage}
        totalPages={this.state.totalPages}
        totalOffers={this.state.totalOffers}
        hasMore={this.state.hasMore}
        offerDate={this.state.offerDate}
        isCheckingEligibility={this.state.isCheckingEligibility}
        eligibilityConfirmOpen={this.state.eligibilityConfirmOpen}
        onRunEligibilityCheckClick={this.onRunEligibilityCheckClick}
        onEligibilityConfirmModalRequestClose={this.onEligibilityConfirmModalRequestClose}
        onRunEligibilityCheckConfirm={this.onRunEligibilityCheckConfirm}
        onRefreshClick={this.onRefreshClick}
        onPreviousPage={this.onPreviousPage}
        onNextPage={this.onNextPage}
        searchQuery={this.state.searchQuery}
        onSearchChange={(q) => this.setState({ searchQuery: q })}
        statusFilter={this.state.statusFilter}
        onStatusFilterChange={(sf) => this.setState({ statusFilter: sf })}
        actionModalOpen={this.state.actionModalOpen}
        selectedItem={this.state.selectedItem}
        actionModalType={this.state.actionModalType}
        onOpenActionModal={this.onOpenActionModal}
        onCloseActionModal={this.onCloseActionModal}
        onActionSuccess={this.onActionSuccess}
      />
    )
  }
}

export default RepeatTransactionPageSF
